// extracted by mini-css-extract-plugin
module.exports = {"center":"NavigationBarHeadingFullCenter_center__3LJFU","left":"NavigationBarHeadingFullCenter_left__3gQNc"};